module.exports = __webpack_public_path__ + "components/rewards/stanford-skiing/static/logo-7d9a212acf45a2d73f66cd2a623b9b66.webp";